<form [formGroup]="registerForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <div class="account-type">
        <mat-radio-group class="mat-radio-group--horizontal" formControlName="accountType" required>
            <mat-radio-button *ngFor="let k of entityLegalTypes" [value]="k.value">{{ k.key }}</mat-radio-button>
        </mat-radio-group>
    </div>
    <div class="errors message-box message--warning" *ngIf="registerFailText$ | async">
        <p [innerHTML]="registerFailText$ | async"></p>
    </div>
    <div class="first-name">
        <mat-form-field appearance="outline">
            <input matInput placeholder="First name" formControlName="firstName" required>
        </mat-form-field>
        <mat-error *ngIf="firstName.touched && firstName.errors?.required">
            First name is required
        </mat-error>
    </div>
    <div class="last-name">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Last name" formControlName="lastName" required>
        </mat-form-field>
        <mat-error *ngIf="lastName.touched && lastName.errors?.required">
            Last name is required
        </mat-error>
    </div>
    <div class="email-address">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Email address" formControlName="email" required>
        </mat-form-field>
        <div *ngIf="email.touched && email.errors">
            <mat-error *ngIf="email.errors?.required">
                Email is required
            </mat-error>
            <mat-error *ngIf="email.errors?.email">
                Enter a valid email address
            </mat-error>
        </div>
    </div>
    <div class="password">
        <mat-form-field appearance="outline">
            <input matInput placeholder="Create password" [type]="hide ? 'password' : 'text'" formControlName="password"
                required>
            <i class="material-icons" (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</i>
        </mat-form-field>
        <mat-error *ngIf="password.touched && password.errors">
            Password must be at least 8 characters and contain at least one uppercase, lowercase and
            a digit or special character
        </mat-error>
        <p class="password smaller">
            Password must be at least 8 characters and contain at least one uppercase, lowercase and
            a digit or special character
        </p>
    </div>
    <div class="terms-conditions" *ngIf="termsOfUse || privacyPolicy">
        <div>
            <mat-checkbox formControlName="tandc" required class="default-element-padding--right"></mat-checkbox>
            <p>
                I accept the
                <a *ngIf="termsOfUse" target="_blank" href={{termsOfUse}}>Terms of Use</a>
                <ng-container *ngIf="termsOfUse && privacyPolicy"> and </ng-container>
                <a *ngIf="privacyPolicy" target="_blank" href={{privacyPolicy}}>Privacy Policy</a>
            </p>
        </div>
    </div>
    <button class="a-rounded-button--primary a-rounded-button" type="submit"
        [disabled]="registerForm?.invalid || isDisabled">Register</button>
</form>
<footer>
    <p>Already have an account? <a routerLink="/auth/signin">Login here</a></p>
    <p>Having trouble registering? <a href={{contactUs}} target="_blank">Contact Us</a></p>
</footer>